import { Channel, LinkTarget } from "core/codegen/types";
import { hardCodedbanners } from "./bannersContent";
export function dataToProgramBannerData(data) {
    switch (data.__typename) {
        case "DefaultVtmGo":
            return {
                __typename: "MarketingBannerVtmGo",
                backgroundColor: hardCodedbanners.vtmgo.backgroundColor,
                description: hardCodedbanners.vtmgo.description,
                image: data.image || hardCodedbanners.vtmgo.image,
                mobileImage: data.mobileImage || hardCodedbanners.vtmgo.mobileImage,
                title: hardCodedbanners.vtmgo.title,
                uuid: hardCodedbanners.vtmgo.uuid,
                cta: {
                    __typename: "CallToAction",
                    link: {
                        __typename: "Link",
                        target: LinkTarget.Self,
                        url: hardCodedbanners.vtmgo.cta.url,
                    },
                    title: hardCodedbanners.vtmgo.cta.label,
                    prefix: null,
                    suffix: null,
                },
                bannerType: hardCodedbanners.vtmgo.bannerType
            };
        case "DefaultVtmGoPlus":
            return {
                __typename: "MarketingBannerVtmGo",
                backgroundColor: hardCodedbanners.vtmgoPlus.backgroundColor,
                description: hardCodedbanners.vtmgoPlus.description,
                image: data.image || hardCodedbanners.vtmgoPlus.image,
                mobileImage: data.mobileImage || hardCodedbanners.vtmgoPlus.mobileImage,
                title: hardCodedbanners.vtmgoPlus.title,
                uuid: hardCodedbanners.vtmgoPlus.uuid,
                cta: {
                    __typename: "CallToAction",
                    link: {
                        __typename: "Link",
                        target: LinkTarget.Self,
                        url: hardCodedbanners.vtmgoPlus.cta.url
                    },
                    title: hardCodedbanners.vtmgoPlus.cta.label,
                    prefix: null,
                    suffix: null
                },
                bannerType: hardCodedbanners.vtmgoPlus.bannerType
            };
        case "MarketingBannerNews":
            return {
                __typename: "MarketingBannerVtm",
                backgroundColor: hardCodedbanners.nieuws.backgroundColor,
                channel: Channel.News,
                description: data.description || hardCodedbanners.nieuws.description,
                image: data.image || hardCodedbanners.nieuws.image,
                mobileImage: data.mobileImage || hardCodedbanners.nieuws.mobileImage,
                title: data.title || hardCodedbanners.nieuws.title,
                uuid: data.uuid,
                cta: {
                    __typename: "CallToAction",
                    link: {
                        __typename: "Link",
                        target: LinkTarget.Self,
                        url: hardCodedbanners.nieuws.cta.url
                    },
                    title: hardCodedbanners.nieuws.cta.label,
                    prefix: null,
                    suffix: null
                },
                bannerType: hardCodedbanners.nieuws.bannerType
            };
        default:
            return data;
    }
}
